<app-admin-form [title]="'SupplierInterface cross'" [object]="settings" [withSettingsSelector]="true"
  (settingsChanged)="settings=$event">

  @for (supplier of adminSettingsService.getAdminSetting(settings,'Suppliers').Value; track $index) {
  <app-admin-custom-control [label]="supplier">
    <ng-container *ngIf="isSupplierEmpty(supplier)" afterLabel>
      <button type="button" class="btn btn-danger btn-sm m-2" (click)="deleteSupplier(supplier)">
        <i class="fas fa-trash-alt"></i></button>
    </ng-container>
    <div class="row">
      <div class="col-4">
        <div class="input-group input-group-sm w-auto">
          <label class="input-group-text" [for]="'interfaceKindSelect_' + $index">InterfaceKind</label>
          <select [id]="'interfaceKindSelect_' + $index" class="form-select"
            [ngModel]="getInterfaceKindFromSupplierInterfaceCross(supplier)"
            (ngModelChange)="setInterfaceKindForSupplierInterfaceCross(supplier, $event)">
            @for (interfaceKind of getFilteredInterfaceKinds(supplier) | keyvalue; track $index) {
            <option [ngValue]="interfaceKind.value">{{interfaceKind.value}}</option>
            }
          </select>
        </div>
      </div>
      <div class="col-4">
        <div class="input-group input-group-sm w-auto">
          <label class="input-group-text" [for]="'brightArticleMappingKey_' + $index">Bright Mapping</label>
          <input [id]="'brightArticleMappingKey_' + $index" class="form-control" type="text"
            [ngModel]="getBrightArticleMappingKey(supplier)"
            (ngModelChange)="setBrightArticleMappingKey(supplier, $event)">
        </div>
      </div>
      <div class="col-4">
        <div class="input-group input-group-sm w-auto">
          <label class="input-group-text" [for]="'brightSupplierNumber_' + $index">Bright Supplier</label>
          <input [id]="'brightSupplierNumber_' + $index" class="form-control" type="text"
            [ngModel]="getBrightSupplier(supplier)" (ngModelChange)="setBrightSupplier(supplier, $event)">
        </div>
      </div>
    </div>
  </app-admin-custom-control>
  }

  <app-admin-cancel-save-button [saveAction]="adminSettingsService.saveSettingsBase(settings)">
    <button type="button" class="btn btn-success ms-2" (click)="addSupplier()"><i class="fas fa-plus"></i>
      Toevoegen</button>
  </app-admin-cancel-save-button>
</app-admin-form>